import { IconButton, Popover } from '@grammarly/design-system'

import styles from './HeaderControls.module.scss'
import type { AgentHeaderControlConfig, PopoverConfig } from '../types'
import React from 'react'

type HeaderControlsProps = {
  type: 'left' | 'right'
  controls: (AgentHeaderControlConfig | null)[]
}

const PopoverWrapper = (props: React.PropsWithChildren<PopoverConfig>) => {
  return props.popoverContentProps ? (
    <Popover {...props.popoverProps}>
      <Popover.Anchor>{props.children}</Popover.Anchor>
      <Popover.Content {...props.popoverContentProps}>{props.content}</Popover.Content>
    </Popover>
  ) : (
    props.children
  )
}

export const HeaderControls: React.FC<HeaderControlsProps> = ({ type, controls }) => {
  return (
    <nav className={[styles.root, styles[type]].join(' ')}>
      {controls.map((control, index) => {
        return control ? (
          <PopoverWrapper {...control.popover} key={index}>
            <IconButton
              ref={control.trackingRef}
              size="small"
              icon={control.icon}
              accessibilityLabel={control.label}
              variant="tertiary"
              onClick={control.onClick}
              isDisabled={control.isDisabled}
            />
          </PopoverWrapper>
        ) : (
          // a placeholder of the control used to occupy the grid slot to balance the layout
          <div key={index} aria-hidden="true" />
        )
      })}
    </nav>
  )
}
